import { PokerVariant } from '@repo/database/src/types';

export interface ComputedGameParams {
  index: number;
  name: string;
  variantId: PokerVariant;
  smallBlind?: number;
  bigBlind?: number;
  smallBet?: number;
  bigBet?: number;
  ante?: number;
  sbAnte?: number;
  bbAnte?: number;
  bringIn?: number;
  bettingCap?: number;
  rakePercent?: number;
  rakeCap?: number;
  rakeCapHU?: number;
}
